module.exports = __webpack_public_path__ + "22f78e9ce1a124a2f79b28d84a961c04.svg";